





























import { Component, Vue } from "vue-property-decorator";
import { Button } from "vant";

@Component({
  components: {
    [Button.name]: Button
  }
})
export default class Login extends Vue {
  showPage = false;
  isLogin = true;
  is_open_account = 0;
  is_verify = 0;
  futures_account = "";
  mt4_login_id = "";
  user_no = "";

  get hasCreateAccount() {
    return this.is_open_account;
  }

  get checking() {
    return this.is_open_account && this.is_verify == 0;
  }

  get checkedFail() {
    return this.is_open_account && this.is_verify == 1;
  }

  get checkedSuccess() {
    return this.is_open_account && this.is_verify == 2;
  }

  created() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.showPage = true;
      this.isLogin = false;
      return;
    }
    (this as any).$apis
      .getAccountStatus()
      .then(res => {
        this.showPage = true;
        const {
          is_open_account,
          is_verify,
          mt4_login_id,
          futures_account,
          user_no
        } = res;
        this.user_no = user_no;
        this.is_open_account = is_open_account;
        this.is_verify = is_verify;
        this.futures_account = futures_account;
        this.mt4_login_id = mt4_login_id;
        
      })
      .catch(e => {
        
      });
  }
}
